<template>
  <div>
    <UiBaseFormVee
      submitOnCtrlEnter
      :errorText="errorText"
      :onSubmit="onSubmit">
      <div class="max-w-xs">
        <RoleSelection
          :user="user"
          v-model:userMainRole="userMainRole" />
      </div>

      <WorkAreaSelection
        :user="user"
        v-model:userWorkAreas="userWorkAreas" />

      <template #buttons>
        <UiBaseButton
          :text="$t('action.save')"
          :isLoading="isSaving"
          :showSaveIcon="showSaveIcon"
          type="submit" />
      </template>
    </UiBaseFormVee>
  </div>
</template>

<script lang="ts">
import type { LabManagementUser } from '@/globals/typescript/models/LabManagementUser'
import { managementApi } from '@/globals/typescript/utils/api/managementClient'
import { useToast } from '@/globals/typescript/utils/toast'
import { useAppStore } from '@/stores/appStore'
import {
  type TLabManagementRole,
  type TLabManagementWorkArea,
} from '@team-milva/lab-models/user'
import { mapState } from 'pinia'
import type { PropType } from 'vue'

export default {
  name: 'ProfileRolesModalPage',
  props: {
    user: {
      type: Object as PropType<LabManagementUser>,
      required: true,
    },
  },
  data() {
    return {
      userMainRole: 'user' as TLabManagementRole,
      userWorkAreas: [] as TLabManagementWorkArea[],

      isSaving: false,
      showSaveIcon: false,
      errorText: '',
    }
  },
  computed: {
    ...mapState(useAppStore, ['defaultMessageSaveIconTime']),
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.setRolesFromUser()
      },
    },
  },
  methods: {
    setRolesFromUser() {
      this.userMainRole = this.user.mainRole
      this.userWorkAreas = [...this.user.workAreas]
    },
    async onSubmit() {
      this.isSaving = true

      try {
        const userValues = {
          mainRole: this.userMainRole,
          workAreas: this.userWorkAreas,
        }

        // TODO: remove cast after deploying and re-running openapi:gen
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = await (managementApi as any)('patch', '/users/{userID}', {
          path: {
            userID: this.user.id,
          },
          body: userValues,
        })
        if (result.success) {
          this.showSaveIcon = true
          setTimeout(() => {
            this.showSaveIcon = false
          }, this.defaultMessageSaveIconTime)
          useToast().success(this.$t('W: Roller gemt'))
          return
        }
        useToast().error(this.$t('W: Kunne ikke gemme roller'))
        this.errorText = this.$t('error.common.standard')
      } finally {
        this.isSaving = false
      }
    },
    resetValidationMessages() {
      this.errorText = ''
    },
  },
}
</script>
